import {Component} from '@angular/core';

@Component({
    selector: 'ca-404',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
}
